export default "/fonts/vendor/devextreme/dist/css/icons/dxicons.ttf?4d3cea0a08c2038308fc35a2eea99a93";